import React, { useState, useEffect, useCallback, useRef } from 'react';
import '../../styles/employee/TopBar.css';
import { connectWebSocket } from "../../services/websocket";
import { toast } from "react-toastify";
import { IoMdCloseCircle } from "react-icons/io";

import "react-toastify/dist/ReactToastify.css";
import './Notification.css'
import '../../styles/user/clientdashboard.css';

const Notification = ({
  fetchNotificationsApi,
  fetchUnreadCountApi,
  markAllReadApi,
  approveApi,
  rejectApi,
  fetchUserApi
}) => {
  // NOTIFICATION STATES
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotify, setShowNotify] = useState(false);
  const [userId, setUserId] = useState(null);
  const processedIdsRef = useRef(new Set());




  // NOTIFICATION HANDLERS
  const handleToggleNotifications = async () => {
    setShowNotify(prev => !prev);
    if (!showNotify) {
      try {
        await markAllReadApi();
        setUnreadCount(0);
      } catch (err) {
        console.error("Mark read error:", err);
      }
    }
  };

  const handleApprove = useCallback(async (notification) => {
    setNotifications(prev => prev.filter(n => n.id !== notification.id));
    setUnreadCount(prev => Math.max(prev - 1, 0));
    try {
      await approveApi(notification.requestId);
      toast.success("Approved");
    } catch (err) {
      setNotifications(prev => [notification, ...prev]);
      setUnreadCount(prev => prev + 1);
      toast.error("Approval Failed");
    }
  }, [approveApi]);

  const handleReject = useCallback(async (notification) => {
    setNotifications(prev => prev.filter(n => n.id !== notification.id));
    setUnreadCount(prev => Math.max(prev - 1, 0));
    try {
      await rejectApi(notification.requestId);
      toast.info("Rejected");
    } catch (err) {
      setNotifications(prev => [notification, ...prev]);
      setUnreadCount(prev => prev + 1);
      toast.error("Rejection Failed");
    }
  }, [rejectApi]);
  const loginedUsername = localStorage.getItem('user_name');


  // API FETCHING
  useEffect(() => {

    if (fetchUserApi) {

      fetchUserApi()

        .then(res => setUserId(res.data.data.userId))

        .catch(console.error);

    }

    fetchNotificationsApi?.().then(data => {

      if (Array.isArray(data)) {

        setNotifications(data);

        data.forEach(n => processedIdsRef.current.add(n.id));

      }

    });

    fetchUnreadCountApi?.().then(setUnreadCount);

  }, []);


  // WEBSOCKET
  useEffect(() => {
    if (!userId) return;
    const client = connectWebSocket(userId, (data) => {
      if (!data || !data.id || processedIdsRef.current.has(data.id)) return;
      processedIdsRef.current.add(data.id);
      setNotifications(prev => [data, ...prev]);
      setUnreadCount(prev => prev + 1);
      toast.info("New Notification");
    });
    return () => client?.deactivate();
  }, [userId]);

  return (
    <div>
      {/* NOTIFICATION SECTION */}
      <div className="notification-bell-container">
        <div className="bell-wrapper" onClick={handleToggleNotifications}>
          <span className="bell-icon">🔔</span>
          {unreadCount > 0 && <span className="unread-badge">{unreadCount}</span>}
        </div>

        {showNotify && (
          <div className="notification-dropdown">
            <div className="notification-header">
              <h4>Notifications</h4>
              <p className='notification-close-icon' onClick={handleToggleNotifications}><IoMdCloseCircle /></p>
            </div>
            <div className="notification-scroll-area">
              {notifications.length === 0 ? (
                <p className="no-notifications">No notifications</p>
              ) : (
                notifications.map((n) => (
                  <div key={n.id} className="notification-card">
                    <p className="notif-message">{n.message || `${n.candidateId} requested update`}</p>
                    <span className="notif-time">
                      {n.notificationTime ? new Date(n.notificationTime).toLocaleString() : "Just now"}
                    </span>
                    {n.status === "PENDING" && (
                      <div className="notif-actions">
                        <button className="btn-approve" onClick={() => handleApprove(n)}>Approve</button>
                        <button className="btn-reject" onClick={() => handleReject(n)}>Reject</button>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Notification
